"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CronjobHttpClient = void 0;
const index_1 = require("../Types/index");
const BaseClient_1 = require("./BaseClient");
const Mappers_1 = require("./Lib/Mappers");
class CronjobHttpClient extends BaseClient_1.BaseClient {
    async getActive(identity, offset, limit) {
        const url = this.buildUrl(index_1.restSettings.paths.getActiveCronjobs, offset, limit);
        const requestAuthHeaders = this.createRequestAuthHeaders(identity);
        const response = await this.httpClient.get(url, requestAuthHeaders);
        const mappedResult = {
            totalCount: response.result.totalCount,
            cronjobs: response.result.cronjobs.map(Mappers_1.mapCronjobConfiguration),
        };
        return mappedResult;
    }
    async queryHistory(query, identity, offset, limit, sortSettings) {
        const url = this.buildUrl(index_1.restSettings.paths.getCronjobHistory, offset, limit, query, sortSettings);
        const requestAuthHeaders = this.createRequestAuthHeaders(identity);
        const response = await this.httpClient.get(url, requestAuthHeaders);
        const mappedResult = {
            totalCount: response.result.totalCount,
            cronjobHistories: response.result.cronjobHistories.map(Mappers_1.mapCronjobHistory),
        };
        return mappedResult;
    }
}
exports.CronjobHttpClient = CronjobHttpClient;
//# sourceMappingURL=CronjobHttpClient.js.map